import { useQuery } from "@tanstack/react-query"

interface ApiService {
  id: string
  service_id: string
  name: string
  has_sub_services: boolean
  special_notes: string | null
  sub_services: Array<{ id: string; name: string; active: boolean }>
}

interface ServicesResponse {
  services: ApiService[]
}

async function fetchServices(branchId: string): Promise<ApiService[]> {
  if (!branchId) return []

  const apiUrl = import.meta.env.VITE_API_URL || import.meta.env.NEXT_PUBLIC_API_URL || ''
  const url = `${apiUrl}/v1/branch_services/findServicesByBranchGuest?branch_id=${encodeURIComponent(branchId)}`
  const res = await fetch(url, { cache: "no-store" })

  if (!res.ok) {
    return []
  }

  const json = (await res.json()) as ServicesResponse
  return Array.isArray(json?.services) ? json.services : []
}

export function useServices(branchId: string) {
  return useQuery({
    queryKey: ["services", branchId],
    queryFn: () => fetchServices(branchId),
    enabled: !!branchId,
  })
}

